export default __webpack_public_path__ + "static/media/29615_KS2_WX1_USA_US101-8_2_T-1_2018b.2c52ad98.gif";